import styled from 'styled-components';
import CancelSuccessSvg from '../../assets/mytrips/cancel-success.svg';

const CancelSuccessIcon = styled(CancelSuccessSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '21rem'};
  height: ${props => props.height || '11.4rem'};
  margin: ${props => props.margin};
  cursor: pointer;
`;

export default CancelSuccessIcon;
